<div *ngIf="!loadedProfile" class="row">
  <nb-actions size="small" class="see-more-button">
    <nb-action (click)="getProfile()">
      <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
      <span class="text-link">Xem thêm thông tin </span>
    </nb-action>
  </nb-actions>
</div>

<div
  *ngIf="loadedProfile"
  class="row"
  [nbSpinner]="loading"
  nbSpinnerStatus="info"
>
  <div class="col-12 col-sm-6 col-md-6">
    <nb-card>
      <nb-card-body>
        <ngx-view-image [imageURL]="imageURL" [size]="'small'"></ngx-view-image>
      </nb-card-body>

      <nb-card-footer>
        <h6 class="text-primary">
          {{ userData ? userData.displayName : "Anonymous" }}
        </h6>
      </nb-card-footer>
    </nb-card>
  </div>

  <div class="col-12 col-sm-6 col-md-6">
    <nb-card>
      <nb-menu [items]="profileItems"> </nb-menu>
    </nb-card>
  </div>
</div>
